import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3a21 21 0 0 0 18 0","key":"svg-0"}],["path",{"d":"M3 21a21 21 0 0 1 18 0","key":"svg-1"}],["path",{"d":"M7 4.5l0 15","key":"svg-2"}],["path",{"d":"M17 4.5l0 15","key":"svg-3"}]]

const IconZodiacGemini = createReactComponent('outline', 'zodiac-gemini', 'ZodiacGemini', __iconNode);

export default IconZodiacGemini;